import { useHistory } from 'react-router-dom';
import classNames from 'classnames';

import { Dropdown, Routes } from 'components/Reusable';

import { useMemoSelector, useWindowSize } from 'hooks';
import { getActiveNavItemId, getIsOpenSidebar, getRoutes } from 'store';
import { SCREEN_BREAKPOINTS } from 'utils';

import globalStyles from 'styles/modules/Global.module.scss';
import styles from './Navbar.module.scss';

const Navbar = (): JSX.Element => {
  const history = useHistory();
  const { width: windowWidth } = useWindowSize();

  const { isOpenSidebar, activeNavItemId, routes } = useMemoSelector((state) => ({
    isOpenSidebar: getIsOpenSidebar(state),
    activeNavItemId: getActiveNavItemId(state),
    routes: getRoutes(state),
  }));

  const isShowDropdown =
    isOpenSidebar && windowWidth < SCREEN_BREAKPOINTS.desktopBig && windowWidth >= SCREEN_BREAKPOINTS.desktopSmall;

  return (
    <div className={styles.navbar}>
      <div
        className={classNames(styles.dropdownContainer, {
          [styles.hide]: !isShowDropdown,
        })}
      >
        <Dropdown
          items={routes}
          onClickItem={(route) => history.push(route.path)}
          activeItemId={activeNavItemId}
          showSelected
        />
      </div>
      <Routes
        itemClassName={globalStyles.navItem}
        activeItemClassName={globalStyles.activeNavItem}
        hideClassName={styles.hideNavbarItem}
        itemsContainerClassName={classNames(styles.itemsContainer, {
          [styles.hide]: isShowDropdown,
        })}
      />
    </div>
  );
};

export default Navbar;
